var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCafs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2409 2.78967C37.794 3.16625 28.7083 5.6822 24.1263 14.547C18.5338 25.364 24.7491 35.7636 25.2067 36.4985C24.8042 36.7346 16.0045 41.74 8.18981 37.4694C2.7223 34.4833 1.30299 28.9059 0.991589 27.6886C-1.35768 18.4594 4.98895 7.72589 14.153 2.88941C25.7214 -3.21522 37.8555 2.1505 39.2409 2.78967Z",
    fill: "#003F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07594 37.3209C5.38509 39.4256 7.99492 42.9695 12.5579 45.8173C19.3875 50.0797 26.2722 50.0899 28.8545 49.9678C31.2461 49.7907 35.879 49.1312 40.6792 46.2142C46.7844 42.5054 49.5234 37.3555 50.4979 35.2466C45.0452 31.9897 40.8318 31.0351 38.5185 30.7012C37.4678 30.5506 36.5738 30.4936 35.5358 30.7012C32.1592 31.375 30.8437 34.1189 28.6469 36.3336C23.4971 41.5243 15.7164 41.5731 15.28 41.5711C10.126 41.5324 6.16465 38.9839 4.0717 37.3229L4.07594 37.3209Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0347 12.5359C29.0875 11.0927 31.3033 8.47498 35.0783 6.59005C37.9402 5.16109 40.5776 4.7092 42.2595 4.55246C43.4903 5.385 44.9541 6.53916 46.3967 8.10044C48.496 10.3742 49.7522 12.6418 50.5 14.3109C50.0446 14.5328 43.162 17.8548 38.7028 18.6141C36.4785 18.9927 35.163 18.6813 34.3601 18.3841C33.7437 18.1561 33.2226 17.8589 32.5828 17.3989C31.5173 16.6335 29.7739 15.1659 28.0347 12.5359Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafs);
export default __webpack_public_path__ + "static/media/cafs.4bcad6aecd5931111981af5dbc9d0a81.svg";
export { ForwardRef as ReactComponent };